import { useState, FormEvent, ReactNode } from 'react';
import { Box, Card, TextField, Button, Typography, Alert } from '@mui/material';
import { adminLogin, getStoredToken, installAdminAuthInterceptors } from './adminAuth';

// Renders the login form until a valid admin token exists, then renders children.
// Must wrap App (not live inside it): App fires all initial fetches on mount, and those
// need the token already present.
function AdminLoginGate({ children }: { children: ReactNode }) {
    installAdminAuthInterceptors();

    const [authed, setAuthed] = useState<boolean>(() => getStoredToken() !== null);
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState<string | null>(null);
    const [submitting, setSubmitting] = useState(false);

    if (authed) {
        return <>{children}</>;
    }

    const handleSubmit = async (e: FormEvent) => {
        e.preventDefault();
        setSubmitting(true);
        setError(null);
        try {
            await adminLogin(username, password);
            setAuthed(true);
        } catch (err: any) {
            setError(err?.message ?? 'Login gagal');
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <Box
            sx={{
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                bgcolor: 'background.default'
            }}
        >
            <Card sx={{ p: 4, width: 360 }}>
                <Typography variant="h3" sx={{ mb: 3 }}>
                    Production Panel
                </Typography>
                <form onSubmit={handleSubmit}>
                    <TextField
                        label="Username"
                        fullWidth
                        autoFocus
                        margin="normal"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                    />
                    <TextField
                        label="Password"
                        type="password"
                        fullWidth
                        margin="normal"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                    {error && (
                        <Alert severity="error" sx={{ mt: 2 }}>
                            {error}
                        </Alert>
                    )}
                    <Button
                        type="submit"
                        variant="contained"
                        fullWidth
                        sx={{ mt: 3 }}
                        disabled={submitting || !username || !password}
                    >
                        {submitting ? 'Masuk...' : 'Masuk'}
                    </Button>
                </form>
            </Card>
        </Box>
    );
}

export default AdminLoginGate;
